import { render, staticRenderFns } from "./FormCreated.vue?vue&type=template&id=dd517902&scoped=true"
import script from "./FormCreated.vue?vue&type=script&lang=js"
export * from "./FormCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd517902",
  null
  
)

export default component.exports